import { app } from '../../../../app';

class SaaspassVpnService{

    /** @ngInject */
    constructor($http) {
        this.$http = $http;
    }

    generateOvpnConfig(companyId,config) {
        return this.$http
            .post(`app/rest/company/${companyId}/ovpn-config/`,config, {responseType : 'arraybuffer'})
            .then(response => response.data);
    }

}

app.service('SaaspassVpnService', SaaspassVpnService);


// WEBPACK FOOTER //
// ./src/portal/states/company/saaspass-vpn/configuration/configuration.service.js